var render, staticRenderFns
import script from "./headling.vue?vue&type=script&lang=ts&"
export * from "./headling.vue?vue&type=script&lang=ts&"
import style0 from "./headling.vue?vue&type=style&index=0&id=0534cbe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534cbe4",
  null
  
)

export default component.exports